import { useState } from 'react';
import { nextWizardStep, previousWizardStep, type WizardStep } from './steps';

type UseWizardNavigationArgs = {
  withRelationships: boolean;
  /** Going back from the first step leaves the wizard. */
  onExit: () => void;
  /** Going forward from the last step creates the sync. */
  onPublish: () => void;
  /** A step is about to show, by any move. */
  onEnter?: (step: WizardStep) => void;
};

/** Which step is shown, and the back/forward moves between them. */
export function useWizardNavigation({ withRelationships, onExit, onPublish, onEnter }: UseWizardNavigationArgs) {
  const [step, setCurrent] = useState<WizardStep>('details');

  const setStep = (next: WizardStep) => {
    onEnter?.(next);
    setCurrent(next);
  };

  const goBack = () => {
    const previous = previousWizardStep(step, withRelationships);
    if (previous == null) {
      onExit();
      return;
    }
    setStep(previous);
  };

  const goNext = () => {
    const next = nextWizardStep(step, withRelationships);
    if (next == null) {
      onPublish();
      return;
    }
    setStep(next);
  };

  return { step, setStep, goBack, goNext };
}
